import { isBlank } from 'utils/object';
/**
 * 字符串正则转义
 * @param str
 * @returns string
 */
export function regExpEscape(str: string) {
  return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

/**
 * 正则拼配
 * @param regStr
 * @param value
 * @returns string
 */
export function regTest(regStr: string, value: string) {
  if (!regStr) {
    return false;
  }
  const escapedValue = regExpEscape(regStr.trim());
  if (escapedValue === '') {
    return false;
  }

  const regex = new RegExp(escapedValue, 'i');
  return regex.test(value);
}

export function getCurrencyPrice(price: any, currency: any) {
  return !isBlank(price) ? `${price} ${currency || ''}` : '--';
}

export function getSplitPriceWithcurrency(price: any) {
  if (typeof price === 'string') {
    const currencyArr = price.match(/\d+[,\d]*(\.\d{2})\D*/g);
    return !!currencyArr ? currencyArr.join('\n') : price;
  } else {
    return isBlank(price) ? '--' : price;
  }
}
